if (!customElements.get('collection-tile-carousel')) {
  
  class CollectionTileCarousel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initCarousel();
    }

    disconnectedCallback() {
      this.slider?.destroy();
      this.slider = null;
    }

    initCarousel() {
      this.slider = new Swiper(this.querySelector(".swiper"), {
        slidesPerView: "auto",
        slidesPerGroup: 1,
        slidesPerGroupAuto: true,
        spaceBetween: 8,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        freeMode: {
          enabled: true,
          momentumRatio: 0.8,
          momentumBounce: false
        },
        breakpoints: {
          481: {
            spaceBetween: 16,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            freeMode: {
              enabled: false
            }
          }
        },
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        }
      });
    }
  }

  customElements.define('collection-tile-carousel', CollectionTileCarousel)
}